<div class="root">
  <app-top-button [linkContents]="linkContents"></app-top-button>
</div>
